<style>
.logo-container {
  max-width: 200px;
  
  overflow: hidden;
  display: inline-block;
  
  font-size: 0;
  vertical-align: top;
  margin-right: 4vw;
  margin-left: 4vw !important;
}
.logo {
  max-width: 200px;
  max-height: 30px;
  border-style: none !important;
  vertical-align: middle;
}
.separator {
  align-self: center;
  background-color: currentColor;
  margin-left: 16px;
  margin-right: 16px;
  height: 28px;
  width: 1px;
  background-color: white;
}

.applicationButton {
  color: white !important;
  text-decoration: none !important;
  vertical-align: middle;
  font-weight: 600;
  font-family: SegoeUI-SemiBold-final, Segoe UI Semibold, SegoeUI-Regular-final,
    Segoe UI, "Segoe UI Web (West European)", Segoe, -apple-system,
    BlinkMacSystemFont, Roboto, Helvetica Neue, Tahoma, Helvetica, Arial,
    sans-serif;
  font-size: 16px !important;
  line-height: 48px;
  -webkit-font-smoothing: antialiased;
    padding-left: 45px;
  padding-right: 50px;
}

.mobileShow {
  display: none !important;
}
.desktopShow {
  display: block;
}
.marginMenu {
  margin-top: 5vh;
}
@media (max-width: 1000px) {
  .mobileShow {
    display: block !important;
  }
  .desktopShow {
    display: none !important;
  }
}

.v-menu__content {
  contain: initial !important;
  overflow-y: initial;
  overflow-x: initial;
}
.mnuBtn {
  background-color: rgba(0, 0, 0, 0) !important;
  color: white;
  box-shadow: rgba(255, 255, 255, 0) 0px 0px 0pt !important;
  display: table;
  font-family: unset !important;
  padding: 1 !important;
  user-select: none;
  cursor: default;
  margin-bottom: 1px;

  border-radius: 0 !important;
}
.menu {
  background-color: #424242 !important;
  color: white !important;
  border-radius: 0 !important;
}
.mnuLst {
  border-radius: 0 !important;
  background-color: #424242 !important;
}

.header-button {
  border-radius: 0% !important;
  padding: 0px !important;
  min-width: 42px !important;
  min-height: 42px !important;
  margin: 0px 1px;
}

.button-flag {
  margin: 0px 0px 0px 24px;
}

.header-button-profile {
  min-height: 42px !important;
  border-radius: 0% !important;
  margin: 0px 0px 0px 24px;
}

.header-button-profile:hover {
  background-color: white;
  color: #5d6367;
}

.header-button:hover,
.header-button.clicked {
  background-color: white;
  color: #5d6367;
}

.header-button:hover {
  background-color: white !important;
  color: #5d6367 !important;
}

.header-button-icon {
  width: 24px;
  font-size: 16px !important;
}

.header-menu-content {
  z-index: 1000;
}

.menuTextColorSelected {
    color: #ffffff;
}

.menuTextColorNotSelected {
    color: #cecece !important;
}

</style>

<template>
  <div>
    <v-app-bar :clipped-left="clipped" app fixed dense dark color="fercamColor" class="mainToolbar">
      <!-- <a class="logo-container">
        <img class="logo" src="https://www.fercam.com/Content/Img/logo_white.png" alt />
      </a>
      <div class="separator"></div> -->
      <a @click="navigateToPod()" class="applicationButton">
        <b>{{ title }}</b>        
      </a>
      <!-- <v-toolbar-side-icon class="mobileShow" @click="drawerData = !drawerData" /> -->
      
      <div v-if="menuVisible">
          <v-btn text v-bind:class="{ menuTextColorSelected: menuItems[0].selected, menuTextColorNotSelected: !menuItems[0].selected }"
          class="userMenu"
          @click="navigateTo(menuItems[0].route)">{{ menuItems[0].title }}</v-btn>

          <v-btn v-if="manageClientsVisible" text v-bind:class="{ menuTextColorSelected: menuItems[1].selected, menuTextColorNotSelected: !menuItems[1].selected }"
          class="userMenu"
          @click="navigateTo(menuItems[1].route)">{{ menuItems[1].title }}</v-btn>

        <!-- <hsc-menu-style-white>
          <hsc-menu-bar>
            <hsc-menu-bar-item
              v-for="(item, index) in menuItems"
              v-bind:key="index"
              text
              :label="item.title"
              v-bind:class="{ menuTextColorSelected: item.selected }"
            >
              <hsc-menu-item
                text
                v-for="(child, index1) in item.child"
                v-bind:key="index1"
                :label="child.title"
                @click="navigateTo(child.route)"
                v-bind:class="{ menuTextColorSelected: child.selected }"
              >
                <hsc-menu-item
                  text
                  v-for="(child2, index2) in child.child"
                  v-bind:key="index2"
                  :label="child2.title"
                  @click="navigateTo(child2.route)"
                  v-bind:class="{ menuTextColorSelected: child2.selected }"
                ></hsc-menu-item>
              </hsc-menu-item>
            </hsc-menu-bar-item>
          </hsc-menu-bar>
        </hsc-menu-style-white> -->
      </div>
      <v-spacer />

      <div class="d-flex align-end flex-row">
        <v-btn
          text
          @click.stop="showSearchMenu()"
          class="userMenu"
          v-bind:class="{ 'clicked': searchMenuDrawer }"
          :style="this.$store.getters.GET_showSearchMenu.style"
        >
          <v-icon class="header-button-icon">fas fa-sliders-h</v-icon>
        </v-btn>
      </div>

      <!--Utenti-->
      <!-- <v-menu :absolute="false" :offset-y="true">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on" class="itemGrey userMenu" :ripple="false">
            {{ name }} &nbsp;
            <v-icon class="header-button-icon">fas fa-user-alt</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="$GAUserAuth.user.isAuthenticated" class="listItemMenu">
            <v-list-item-action>
              <v-icon class="header-button-icon">fas fa-user-alt</v-icon>
              <span class="headline">{{ userName }}</span>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $GAUserAuth.user.username }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>

          <v-list-item v-if="$GAUserAuth.user.isAuthenticated">
            <v-list-item class="v-list-item-no-padding">
            <v-list-item-action>
              <v-icon class="header-button-icon">fas fa-globe-americas</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t("header.Lingua") }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
            
            <div v-for="(item, index) in supportedLanguages"
                :key="index"
                @click="changeLanguage(item.code, true)" v-bind:class="(index==supportedLanguages.length-1) ? 'languageMenuLastDiv':'languageMenuDiv'">
                <div v-bind:style="isLanguageSelected(item.code) ? 'font-weight: bold; text-align: center; cursor: pointer;' : 'font-weight: normal; text-align: center; cursor: pointer;'">{{ item.code.toUpperCase() }}</div>              
              </div>


            <v-list-item-content>
              <v-list-item-title></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="!$GAUserAuth.user.isAuthenticated" @click="login">
            <v-list-item-action>
              <v-icon class="header-button-icon">fas fa-sign-in-alt</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Login</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-else @click="logout">
            <v-list-item-action>
              <v-icon class="header-button-icon">fas fa-sign-out-alt</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu> -->
    </v-app-bar>
  </div>
</template>

<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";

export default {
  props: {
    clipped: Boolean,
    drawer: Boolean,
    fixed: Boolean,
    items: Array,
    title: String,
    userName: String,
    refresh: Boolean
  },

  async created() {
    // todo: pass the logged user's mail
    // await this.$GAUserAuth.refreshUserInfo()
    // eslint-disable-next-line
    await this.$GAUserAuth.refreshUserInfo().then(res => {
      var email = this.$GAUserAuth.user.username;
      this.name =
        email
          .substring(0, 11)
          .split(".")[0]
          .charAt(0)
          .toUpperCase() +
        email
          .substring(0, 11)
          .split(".")[0]
          .slice(1);
    });

    // set the right language at startup
   if (!localStorage.getItem("Language")) {
     localStorage.setItem("Language","it");     
   }
   
    Trans.changeLanguage(localStorage.getItem("Language")).then(() => {
      this.setMenuItems();
    });

    this.showMenu();    
  },
  mounted() {
    this.drawerData = false;
  },
  data() {
    return {
      drawerData: this.drawer,
      name: "",
      menuVisible: true,
      ManageClientsFunction: process.env.VUE_APP_MANAGE_CLIENTS,
      //ManageClientsFunction: "ViewWarehouses|R",
      manageClientsVisible: false,
      menuItems: [
        {
          title: Trans.i18n.t("header.Menu1"),
          selected: false,
          route: "/POD/Index",          
        },
        {
          title: Trans.i18n.t("header.Menu2"),
          route: "/ClientConfiguration/Index",
          selected: false,          
        }
      ],
      searchMenuDrawer: {
        show: null,
        style: null
      }
    };
  },

  watch: {
        $route: {            
            handler(to, from) {
              
                if (to.path.indexOf("/POD/Index") > -1) {
                  this.menuItems[0].selected=true;
                  this.menuItems[1].selected=false;
                }
                else if (to.path.indexOf("/ClientConfiguration/Index") > -1){
                  this.menuItems[0].selected=false;
                  this.menuItems[1].selected=true;
                }
                else {
                  this.menuItems[0].selected=false;
                  this.menuItems[1].selected=false;
                }
            }
        },
    },

  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    }
  },

  methods: {
    
    showMenu() {
      this.$GAUserAuth.canRead(this.ManageClientsFunction).then(r => {
        //console.log("manage clients", r);
        this.manageClientsVisible = r;
      });
    },
    isCurrentLanguage(lang) {
      return lang === this.currentLanguage;
    },
    changeLanguage(lang, save) {
      if (save) {
        localStorage.setItem("Language", lang);
      }
      const to = this.$router.resolve({ params: { lang } });
      return Trans.changeLanguage(lang).then(() => {
        this.setMenuItems();
        this.$router.push(to.location);
      });
    },

    setMenuItems() {
      let menuItems = this.getItemsMenu();
      var pathname = location.pathname.split("/");
      pathname.shift();
      pathname.shift();
      var searchRoute = "/" + pathname.join("/");
      //console.log("header created", searchRoute);
      for (let index = 0; index < menuItems.length; index++) {
        var res = this.findParents(menuItems[index], searchRoute);
        if (res) menuItems[index].selected = true;
      }

      this.menuItems = menuItems;
      localStorage.setItem("menu", JSON.stringify(menuItems));
    },

    getItemsMenu() {
      let menuItems = [
        {
          title: Trans.i18n.t("header.Menu1"),
          selected: false,
          route: "/POD/Index",          
        },
        {
          title: Trans.i18n.t("header.Menu2"),
          route: "/ClientConfiguration/Index",
          selected: false,          
        }
      ];
      return menuItems;
    },

    findParents(node, searchForName) {
      // If current node name matches the search name, return
      // empty array which is the beginning of our parent result
      if (node.route === searchForName) {
        return [];
      }

      // Otherwise, if this node has a tree field/value, recursively
      // process the nodes in this tree array
      if (Array.isArray(node.child)) {
        for (var treeNode of node.child) {
          // Recursively process treeNode. If an array result is
          // returned, then add the treeNode.name to that result
          // and return recursively
          const childResult = this.findParents(treeNode, searchForName);

          if (Array.isArray(childResult)) {
            //console.log("child", treeNode.title);
            treeNode.selected = true;
            return [treeNode.title].concat(childResult);
          }
        }
      }
    },

    showSearchMenu() {
      if (this.$store.getters.GET_showSearchMenu.show) {
        let showSM = {
          show: false,
          style: "color: #cecece"
        };
        this.$store.commit("SET_showSearchMenu", showSM);
      } else {
        let showSM = {
          show: true,
          style: "color: white"
        };
        this.$store.commit("SET_showSearchMenu", showSM);
      }
      this.searchMenuDrawer = this.$store.getters.GET_showSearchMenu;

      return this.$store.getters.GET_showSearchMenu;
    },

    isLanguageSelected(lang) {
      return localStorage.getItem("Language", lang) == lang;
    },

    navigateTo(a) {
      location.href = "/" + this.currentLanguage + a;
    },

    navigateToPod() {
        router.push({ name: "Index" });
    }
    // async login() {
    //   await this.$GAUserAuth.signin();
    // },
    // async logout() {
    //   await this.$GAUserAuth.signout();
    // }
  }
};
</script>

